import React, { Component, Fragment } from 'react';
import MetaTags from "react-meta-tags";
import Breadcrumb from "../layouts/Breadcrumb";
import Header from '../layouts/Headerthree';
import Footer from '../layouts/Footerthree';
import Content from '../sections/Portfolioslider/Content';

class Portfolioslider extends Component {
    render() {
        return (
            <Fragment>
                <MetaTags>
                    <title>Onitir | Portfolio Slider</title>
                    <meta
                        name="description"
                        content="#"
                    />
                </MetaTags>
                <Header />
                <Breadcrumb breadcrumb={{pagename:'Portfolio'}} />
                <Content/>
                <Footer />
            </Fragment>
        );
    }
}

export default Portfolioslider;